import { render, staticRenderFns } from "./select-version.vue?vue&type=template&id=3439c527&scoped=true&"
import script from "./select-version.vue?vue&type=script&lang=js&"
export * from "./select-version.vue?vue&type=script&lang=js&"
import style0 from "./select-version.vue?vue&type=style&index=0&id=3439c527&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439c527",
  null
  
)

export default component.exports